import { Logger, strategies } from '@craft/logging';

import { AppName, AppVersion } from './constants';

export const logger = Logger.create({
  appName: process.env.APP_NAME ?? AppName,
  appVersion: process.env.APP_VERSION ?? AppVersion,
  isEnabled: !(process.env.NODE_ENV === 'test' || process.env.JEST_WORKER_ID),
  strategies: [
    new strategies.DataDogRumStrategy({ isEnabled: process.env.NODE_ENV === 'production' }),
    new strategies.PinoStrategy({ browser: process.env.NODE_ENV === 'development' }),
  ],
});
